import { combineReducers } from 'redux';
import allReducer from './allReducer';

const rootReducer = combineReducers(allReducer);

export default rootReducer;
